// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["web/assets/dist/css/legacy","web/assets/dist/css/main"], () => (__webpack_require__("./web/assets/src/js/app.js")))
__webpack_require__.O(undefined, ["web/assets/dist/css/legacy","web/assets/dist/css/main"], () => (__webpack_require__("./web/assets/src/styles/main.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["web/assets/dist/css/legacy","web/assets/dist/css/main"], () => (__webpack_require__("./web/assets/src/styles/legacy.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
